import { useState } from "react";
import hm2 from "../assets/kylpyhuone2.png";
import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../utils/imageUrl";

const STYLE_OPTIONS = [
  { key: "basic", label: "BASIC" },
  { key: "moderni", label: "MODERNI" },
  { key: "skandinaavi", label: "SKANDINAAVINEN" }
];

export default function ProductGrid({
  options,
  selectedOptions,
  onSelect,
  userRole,
  voteStatus,
  selections,
  onVoteOption,
  votingBusy,
  voteOutcomeChanges = {}
}) {
  const navigate = useNavigate();
  const [activeStyle, setActiveStyle] = useState(null);
  const img = hm2;

  const selectableCategories = Object.entries(options || {})
  .filter(([_, products]) => Array.isArray(products) && products.length > 0)
  .map(([category]) => category);

  const allCategoriesSelected = selectableCategories.every(
    (category) => selectedOptions.byCategory?.[category]
  );

  const filterByStyle = (products) => {
    if (!activeStyle) return products;
    return products.filter((p) => p.style === activeStyle);
  };

  const isBoardMember = userRole === "board_member";
  const votingOpen = voteStatus?.status === "vote_launched";
  const hasEditRights = ["chairman", "selection_delegate"].includes(userRole);
  const canEditSelections = hasEditRights && voteStatus?.status === "incomplete";

  function handleNext() {
    if (!allCategoriesSelected) return;
    navigate("/cart");
  }

  return (
    <div className="pg-container">
      <div
        className="pg-style-banner"
        style={{
          backgroundImage: `url(${img})`
        }}>

        <div className="pg-style-filter">
          {STYLE_OPTIONS.map((s) => (
            <button
              key={s.key}
              className={
                activeStyle === s.key
                  ? "pg-style-btn active"
                  : "pg-style-btn"
              }
              onClick={() =>
                setActiveStyle(activeStyle === s.key ? null : s.key)
              }>{s.label}
            </button>
          ))}
        </div>
      </div>

      {Object.entries(options).map(([category, products]) => {
        const filteredProducts = filterByStyle(products);
        if (filteredProducts.length === 0) return null;

        return (
          <section key={category} className="pg-section card-box">
            <div className="category-title-wrapper">
              <p className="category-title">{category}</p>

              <div className="selection-display">
                <span className="default-text"><strong>Valittu:</strong></span>
                <span className="selected-badge"
                  title={
                    selectedOptions.byCategory?.[category]
                      ? products.find(p => p.id === selectedOptions.byCategory[category])?.name
                      : "ei valintoja"
                  }
                >
                  {selectedOptions.byCategory?.[category]
                    ? products.find(p => p.id === selectedOptions.byCategory[category])?.name
                    : "ei valintoja"}
                </span>
              </div>
            </div>

            <div className="pg-grid">
              {filteredProducts.map((p) => (
                <div className="pg-card" key={p.id}>
                  {(() => {
                    const categorySelection = selections?.find((sel) => sel.category_name === category);
                    const selectedProductId = selectedOptions.byCategory?.[category];
                    const isSelectedProduct = Number(selectedProductId) === Number(p.id);
                    const myAlternativeSelectableId = Number(categorySelection?.my_alternative_selectable_item_id);
                    const isMyVote = (categorySelection?.my_vote_type === "agree" && isSelectedProduct)
                      || (categorySelection?.my_vote_type === "alternative" && myAlternativeSelectableId === Number(p.selectable_item_id));
                    const canVoteProduct = Boolean(categorySelection?.selectable_item_id)
                      && (isSelectedProduct || Boolean(p.selectable_item_id));

                    if (!isBoardMember || !votingOpen) return null;

                    return (
                      <button
                        type="button"
                        className={`vote-button ${isMyVote ? "selected" : ""}`}
                        disabled={votingBusy || !canVoteProduct}
                        onClick={() => onVoteOption(category, p)}
                        style={{ marginBottom: "8px" }}
                      >
                        {isMyVote ? "Äänestetty" : "Äänestä"}
                      </button>
                    );
                  })()}

                  <div className="pg-img-wrap">
                    <img
                      src={getImageUrl(p.image)}
                      alt={p.name}
                      onError={(e) =>
                        (e.currentTarget.src = "https://via.placeholder.com/300x200")
                      }
                      className="pg-image"
                    />

                    <button
                      className={
                        selectedOptions.all.includes(p.id)
                          ? "pg-btn selected pg-btn-float"
                        : "pg-btn pg-btn-float"
                      }
                      disabled={!canEditSelections}
                      onClick={() => onSelect(category, p.id, "product")}
                    >
                      {selectedOptions.all.includes(p.id) ? (
                        <i className="fa-solid fa-check" />
                    ) : (
                        <i className="fa-solid fa-plus" />
                      )}
                    </button>
                  </div>
                  
                    {voteOutcomeChanges?.[category] && Number(voteOutcomeChanges[category].toId) === Number(p.id) && (
                      <span
                        className="vote-change-badge"
                        title={`Valinta muuttui äänestyksessä: ${voteOutcomeChanges[category].fromName} -> ${voteOutcomeChanges[category].toName}`}
                      >
                        <i className="fa-solid fa-circle-info" aria-hidden="true" />
                        Äänestyksessä muutettu
                      </span>
                    )}

                  <h3 className="pg-title">
                    <a href={`/product/${p.id}`} className="pg-link">
                      {p.name}
                    </a>
                  </h3>

                  <p className="pg-sub">{p.description}</p>
                </div>
              ))}
          </div>
        </section>
      );
    })}

    <div className="next-button-container">
      <button className="next-button" disabled={!allCategoriesSelected}
        onClick={handleNext}>Valintojen yhteenveto
      </button>
    </div>
    </div>
  );
}
